/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/798/interface/api/cat_9022
 */

import { message } from 'ant-design-vue'
import {
  addressValidate_countryList_get,
  addressValidate_detail_get,
  addressValidate_edit_post,
  addressValidate_operateLog_get,
  addressValidate_pageByCondition_post,
  addressValidate_updateStatus_post
} from 'server/modules/9022'

// 国家选项列表
export const addressValidate_countryList_get_ = async function(params) {
  const { success, data, retInfo } = await addressValidate_countryList_get(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 地址策略详情
export const addressValidate_detail_get_ = async function(params) {
  const { success, data, retInfo } = await addressValidate_detail_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 编辑地址策略
export const addressValidate_edit_post_ = async function(params) {
  const { success, data, retInfo } = await addressValidate_edit_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询操作日志
export const addressValidate_operateLog_get_ = async function(params) {
  const { success, data, retInfo } = await addressValidate_operateLog_get(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分页查询地址策略
export const addressValidate_pageByCondition_post_ = async function(params) {
  const { success, data, retInfo } = await addressValidate_pageByCondition_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 更改策略状态
export const addressValidate_updateStatus_post_ = async function(params) {
  const { success, data, retInfo } = await addressValidate_updateStatus_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
